module.exports = "/_next/static/images/DebugYourData@2x-22b454147547aefc4d33fd49a142c26b.png";